// extracted by mini-css-extract-plugin
export default {"container":"style__container___wdlbT","touchable":"style__touchable___a7SpK","scrollView":"style__scrollView___pLFkC"};